"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncModeTypes = void 0;
exports.syncModeTypes = ['add', 'update', 'upsert', 'delete', 'mirror'];
//# sourceMappingURL=types.js.map